import _http from './_http';
import { DOCUMENT_STATUSES } from '@/modules/definitions';
import { DOCUMENT_NAMES } from '@/core/field-names';
import { logWebHrError } from '@/core/logger/log-wrapper';
let http = _http;
const baseUrl = '/onboarding';
const baseUrlDocuments = 'documents';

const filterContentFieldBeforeSave = (document) => {
  if (document.fields instanceof Array) {
    for (let i = 0; i < document.fields.length; i++) {
      if ('CONTENT' === document.fields[i].type) {
        document.fields.splice(i, 1);
      }
    }
  }

  return document;
};

const create = (onboardingId, document) =>
  http
    .post(`${baseUrl}/${onboardingId}/${baseUrlDocuments}`, document)
    .then(({ data }) => data.data)
    .catch((e = {}) => {
      logWebHrError({
        message: 'create request error',
        source: 'documents.js',
        metadata: {
          baseUrl,
          onboardingId,
          baseUrlDocuments,
        },
        error: e,
      });

      if (e.response && e.response.data) {
        throw e.response.data.error;
      }

      throw e;
    });

const update = (onboardingId, id, document) => {
  return http
    .put(`${baseUrl}/${onboardingId}/${baseUrlDocuments}/${id}`, document)
    .then(({ data }) => data.data)
    .catch((e = {}) => {
      logWebHrError({
        message: 'update request error',
        source: 'documents.js',
        metadata: {
          baseUrl,
          onboardingId,
          baseUrlDocuments,
          documentId: id,
        },
        error: e,
      });

      if (e.response && e.response.data) {
        throw e.response.data.error;
      }

      throw e;
    });
};

export default {
  url: `${http.baseUrl}/${baseUrlDocuments}`,
  save(onboardingId, document) {
    if (!(document instanceof Array)) {
      document = [document];
    }

    return Promise.all(
      document
        .filter((doc) => doc.name !== DOCUMENT_NAMES.SUPER_API)
        .map((doc) => {
          filterContentFieldBeforeSave(doc);

          doc.status =
            doc.completion < 100
              ? DOCUMENT_STATUSES.DOCUMENT_IN_PROGRESS
              : DOCUMENT_STATUSES.DOCUMENT_SUBMITTED;

          if (doc.id) {
            return update(onboardingId, doc.id, doc);
          }

          return create(onboardingId, doc);
        })
    );
  },
  get(onboardingId, id) {
    if (process.env.MOCK) {
      // TODO: implement this pathway
      // if (process.env.MOCK_DOCUMENTS.success === false) {
      // }

      return Promise.resolve().then(() => process.env.MOCK_DOCUMENTS.data);
    }

    const documentId = id ? `/${id}` : '';
    return http
      .get(`${baseUrl}/${onboardingId}/${baseUrlDocuments}${documentId}`)
      .then(({ data }) => data.data);
  },
  create,
  update,
};
